import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import 'contents/assets/scss/page/student.scss';

function SatisfactionExternal() {
  const [modalOpen, setModalOpen] = useState(true);
  return (
    <main className="com_container">
      <Modal open={modalOpen} close={() => setModalOpen(false)} type="pop_class_request">
        <h2 className="pop_tit">배정 요청서</h2>
        <button type="button" className="btn_close"></button>
        <div className="content_container">
					{/* 20250218 퍼블 추가 & 수정(명칭및내용전체변경 */}
          <div className="com_info center">
            <p className="name">요청일 : 2024, 05, 12 ㅣ 12 : 30</p>
          </div>
          <div className="request_notice">
            <p className="tit">배정 요청서가 도착했습니다.</p>
            <p className="desc">
              귀하께서는 오랜 시간 수업을 진행하지 않아 현 수업이 가능한지와
              <br />
              일정이 이상 없는지 확인이 필요합니다.
            </p>
            <div className="com_radio_wrap center">
              <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
              <label htmlFor="rdo01">수업 승인</label>
              <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
              <label htmlFor="rdo02">수업불가</label>
            </div>
          </div>
          <div className="request_notice light_orange">
            <div className="desc">
              지금 ‘마이페이지‘ 로 이동하여
              <br />
              수업가능지역, 수업가능 타임, 화상시강 가능 일정을
              <br />
              다시 확인하고 등록하세요.
            </div>

            <button className="com_btn xs orange">등록하러 가기 →</button>
          </div>

          <div className="com_red_txt">
            ※ 본 요청서 확인 후 10일 이내 회신이 없을 경우 수업불가 의사로 간주하고 ERP 계정 삭제 등 계약 종료를 진행합니다.
            <br />
            ※ 계약 종료 후 재입사하시는 경우 신규강사 교육 등 강사 계약 절차를 다시 진행합니다.
            <br />※ 계약 종료 시 기존 시수 및 포인트는 초기화되는 점 알려드립니다.
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn orange xs">확 인</button>
        </div>
      </Modal>
    </main>
  );
}

export default SatisfactionExternal;
